<template>
  <div style="position:relative;">
    <div id="preview" ref="preview">
      <v-layout
        row
        v-for="component in $store.state.chosenComponents"
        :key="component.id" :data-component="component.title"
      >
        <v-flex xs12 >
          <div
            v-if="(componentTitle(component.title) in $options.components) && showComponents"
            :is="componentTitle(component.title)" :key="component.id" :component="component"
            class="webdash-component"
            :style="[brandData.colors, brandData.fonts, brandData.borderRadius]"
            :images="brandData.images"
            :logoURL="logoURL"
          ></div>
          <v-img v-else width="100%" :src="imagePreview(component)"></v-img>
        </v-flex>
      </v-layout>
      <v-layout row class="gray-bg">
        <v-flex md6 xs12 offset-md3>
          <v-card class="mx-auto my-5 pa-4 preview-list">
            <v-list subheader>
              <v-subheader>Featured Components:</v-subheader>
              <template v-for="component in $store.state.chosenComponents">
                <v-list-tile :key="component.id">
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-text="component.title"
                    ></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import webdashComponents from "../webdash_components";
import { mapGetters, mapState } from "vuex";

export default {
  props: ["screenNumber", "logoURL"],
  data() {
    return {
      navComponents: this.$store.state.navComponents,
      bodyComponents: this.$store.state.bodyComponents,
      footerComponents: this.$store.state.footerComponents,
      showComponents: false,
      brand: this.$store.state.chosenBrand
    };
  },
  created() {
    this.showComponents = true;
  },
  mounted () {
    window.scrollTo(0, 0);
    document.getElementById('app').scrollIntoView();

    let headings = $('.webdash-component').find(":header")
    let links = $('.webdash-component').find("a, button, .form-control, .btn, input")
    if (this.brand === 'chevrolet' || this.brand === 'hyundai' || this.brand === 'mazda') {
      headings.css({ textTransform:'uppercase'});
    }
    if (this.brand === 'mazda') {
      headings.css({ textTransform:'uppercase', letterSpacing:'1px'});
      links.css({ textTransform:'uppercase', fontSize:'13px', letterSpacing:'2px', borderRadius:'3px'});
    }
  },
  beforeDestroy() {
    this.showComponents = false;
  },
  computed: {
    ...mapState(['chosenBrand']),
    ...mapGetters(["imagePreview", "brandData"]),
  },
  methods: {
    componentTitle(title) {
      return title.toLowerCase().replaceAll(" ", "-");
    },
    shoot() {
      this.$html2canvas(document.querySelector("#preview")).then(function(
        canvas
      ) {
        canvas.toBlob(function(blob) {
          saveAs(blob, "homepage.png");
        });
      });
    }
  },
  components: webdashComponents
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.v-list__tile:before {
  content: "";
  height: 2px;
  width: 8px;
  background: #777;
  margin-right: 10px;
}
.v-btn {
  z-index: 15;
}
.camera-btn {
  background-color: #006AFF !important;
}
.gray-bg {
  background: #eee;
  margin-bottom: -24px;
}
</style>

<style>
#preview .preview-list .v-list__tile:before {
  content: "";
  height: 2px;
  width: 8px;
  background: #777;
  margin-right: 10px;
}
#preview .preview-list {
  box-shadow: 1px 1px 10px 5px rgba(0,0,0,0.05) !important;
  border-radius: 0px !important;
}
#preview .navbar-nav a, #preview .contact-toolbar-dark-component a {
  letter-spacing: 0px !important;
  border-radius: 0 !important;
}
#preview .webdash-component, #preview .webdash-footer {
  font-family: var(--body-text);
}
#preview .webdash-component h1, #preview .webdash-component h2,
#preview .webdash-footer h1, #preview .webdash-footer h2 {
  font-family: var(--heading-text);
}
#preview .webdash-component h3, #preview .webdash-footer h3, #preview .webdash-component h4, #preview .webdash-footer h4, #preview .webdash-component h5, #preview .webdash-footer h3, #preview .webdash-component h6, #preview .webdash-footer h6 {
  font-family: var(--subheading-text);
}
#preview .webdash-component .strong {
  font-family: var(--bold-text);
}
</style>
